module.exports = __webpack_public_path__ + "img/24.ee7e9023.jpg";